// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1PJHu","dragIcon":"SortableItem_dragIcon__27yR1","disabled":"SortableItem_disabled__1nYYU"};